var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-row',{staticClass:"row",attrs:{"type":"flex","justify":"center"}},_vm._l((_vm.list),function(li,index){return _c('van-col',{key:index,attrs:{"span":"9"}},[_c('common-link',{attrs:{"item":li,"page":_vm.tablist}})],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc66951","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tablist.vue
// module id = null
// module chunks = 